export default "__VITE_ASSET__DxxZeGj9__"